<div
    style="background: white; padding: 30px; margin-bottom: 40px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1); border-top: 4px solid #2c5aa0;">
    <div style="text-align: center; margin-bottom: 25px;"><img style="max-width: 150px; height: auto;"
            src="https://foto.erikslada.se/Logo.png" alt="Min Fotot&auml;vling Logotyp" /></div>
    <h1 style="color: #2c5aa0; text-align: center; margin-bottom: 10px; font-size: 1.6em; font-weight: 600;">Inbjudan
        till <%= competition.CompetitionName %>
    </h1>
    <p style="text-align: center; font-size: 1.0em; color: #666; margin-bottom: 25px;">
        <strong><%= competition.CompetingClub %></strong>
    </p>
    <p>B&auml;sta fotografiintresserade,</p>
    <p>Vi har n&ouml;jet att bjuda in dig till <%= competition.CompetitionName %>, en fotografisk t&auml;vling som ger
            dig m&ouml;jlighet att dela din kreativa vision och uppskatta andras konstn&auml;rliga uttryck.</p>
    <p>Denna t&auml;vling erbjuder en plattform f&ouml;r fotografer att visa sina f&auml;rdigheter.</p>
    <div
        style="background-color: #e8f4fd; padding: 20px; border-radius: 6px; border-left: 4px solid #2c5aa0; margin: 20px 0;">
        <h3 style="color: #1a4480; margin-top: 0; font-size: 1.1em;">T&auml;vlingens Tema</h3>
        <ul style="color: #1a4480; margin: 10px 0; padding-left: 20px;">
            <% competition.subCompetitions.map(theme=> { %>
                <li style="margin-bottom: 5px; font-weight: 600;">
                    <%= theme.SubName %>
                </li>
                <% }); %>
        </ul>
        <p style="color: #1a4480; font-size: 0.95em;">Vi ser fram emot att se din kreativa tolkning av dessa teman.</p>
    </div>
    <div
        style="background-color: #fff3cd; padding: 18px; border-radius: 6px; border-left: 4px solid #856404; margin: 20px 0;">
        <h3 style="color: #856404; margin-top: 0; font-size: 1.1em;">Viktiga Datum</h3>
        <% if (invitation.CanParticipate) { %>
        <p style="margin: 8px 0; color: #856404;"><strong>Sista dag f&ouml;r deltagande:</strong>
            <%= competition.EndoParticipation %>
        </p>
        <% } %>
        <% if (invitation.CanVote) { %>
        <p style="margin: 8px 0; color: #856404;"><strong>Sista dag f&ouml;r r&ouml;stning:</strong>
            <%= competition.EndOfVoting %>
        </p>
        <% } %>
    </div>
    <div
        style="background-color: #f8f9fa; padding: 20px; border-radius: 6px; border-left: 4px solid #6c757d; margin: 20px 0;">
        <h3 style="color: #495057; margin-top: 0; font-size: 1.1em;">Registrering och Inloggning Kr&auml;vs</h3>
        <p style="color: #495057;">F&ouml;r att s&auml;kerst&auml;lla en r&auml;ttvis t&auml;vling och korrekt hantering
            av bidrag kr&auml;vs att alla deltagare &auml;r registrerade och inloggade. Detta m&ouml;jligg&ouml;r
            &auml;ven att systemet f&ouml;rhindrar att deltagare r&ouml;star p&aring; sina egna bilder i
            klubbt&auml;vlingar.</p>
        <p style="color: #495057; margin: 15px 0;"><strong>Registrering (eng&aring;ngsf&ouml;rfarande):</strong><br />
            Nya anv&auml;ndare beh&ouml;ver skapa ett konto f&ouml;r att kunna delta.<br /> <a
                style="color: #2c5aa0; text-decoration: none; font-weight: 500;"
                href="https://foto.erikslada.se/assets/registrera.mp4">&rarr; Se registreringsinstruktioner</a></p>
        <p style="color: #495057;"><strong>Inloggning (kr&auml;vs vid varje bes&ouml;k):</strong><br /> Logga in med
            dina uppgifter f&ouml;r att f&aring; tillg&aring;ng till t&auml;vlingsfunktionerna.<br /> <a
                style="color: #2c5aa0; text-decoration: none; font-weight: 500;"
                href="https://foto.erikslada.se/assets/registrera.mp4">&rarr; Inloggningsinstruktioner</a></p>
    </div>
    <% if (invitation.CanParticipate) { %>
        <div
            style="background-color: #d1ecf1; padding: 20px; border-radius: 6px; border-left: 4px solid #0c5460; margin: 20px 0;">
            <h3 style="color: #0c5460; margin-top: 0; font-size: 1.1em;">Information f&ouml;r T&auml;vlande</h3>
            <p style="color: #0c5460;">Som t&auml;vlande har du m&ouml;jlighet att visa upp dina fotografiska
                f&auml;rdigheter och konkurrera om erk&auml;nnande f&ouml;r din konstn&auml;rliga vision.</p>
            <p style="color: #0c5460; margin: 15px 0;"><strong>F&ouml;rdelar som t&auml;vlande:</strong></p>
            <ul style="color: #0c5460; margin-left: 20px;">
                <li>Visa upp dina b&auml;sta fotografiska verk</li>
                <li>F&aring; professionell bed&ouml;mning och feedback</li>
                <li>M&ouml;jlighet att vinna priser och erk&auml;nnande</li>
            </ul>
            <p style="color: #0c5460; margin: 15px 0;"><strong>S&aring; l&auml;gger du till dina bilder:</strong><br />
                Efter registrering och inloggning kan du enkelt ladda upp dina bidrag via v&aring;rt system.<br /> <a
                    style="color: #0c5460; text-decoration: none; font-weight: 500;"
                    href="https://foto.erikslada.se/assets/addimage.mp4">&rarr; Se detaljerade instruktioner f&ouml;r
                    bilduppladdning</a></p>
        </div>
        <% } %>
            <% if (invitation.CanVote) { %>
                <div
                    style="background-color: #d4edda; padding: 20px; border-radius: 6px; border-left: 4px solid #155724; margin: 20px 0;">
                    <h3 style="color: #155724; margin-top: 0; font-size: 1.1em;">Information f&ouml;r R&ouml;stare</h3>
                    <p style="color: #155724;">Som r&ouml;stare spelar du en viktig roll i att bed&ouml;ma och
                        erk&auml;nna fotografisk excellens. Din bed&ouml;mning bidrar till att identifiera de mest
                        framst&aring;ende verken.</p>
                    <p style="color: #155724; margin: 15px 0;"><strong>Dina m&ouml;jligheter som r&ouml;stare:</strong>
                    </p>
                    <ul style="color: #155724; margin-left: 20px;">
                        <li>Granska och bed&ouml;ma alla t&auml;vlingsbidrag</li>
                        <li>P&aring;verka resultatet genom din r&ouml;st</li>
                        <li>Vara en del av den fotografiska gemenskapen</li>
                    </ul>
                    <p style="color: #155724; margin: 15px 0;"><strong>R&ouml;stningsprocess:</strong><br /> Efter
                        registrering och inloggning f&aring;r du tillg&aring;ng till alla bidrag och kan avge dina
                        r&ouml;ster.<br /> <a style="color: #155724; text-decoration: none; font-weight: 500;"
                            href="https://foto.erikslada.se/assets/vote.mp4">&rarr; Se instruktioner f&ouml;r
                            r&ouml;stning</a></p>
                </div>
                <% } %>
                    <div style="text-align: center; margin: 30px 0;"><a
                            style="display: inline-block; background-color: #2c5aa0; color: white; padding: 14px 32px; text-decoration: none; border-radius: 4px; font-weight: 600; font-size: 1.0em; box-shadow: 0 2px 4px rgba(44, 90, 160, 0.2); transition: background-color 0.3s ease;"
                            href="https://foto.erikslada.se/invitation/<%= invitation.Hash %>"> Anm&auml;l dig h&auml;r
                        </a></div>
                    <p>Vi ser fram emot ditt deltagande och att v&auml;lkomna dig till v&aring;r fotografiska gemenskap.
                    </p>
                    <p style="margin-top: 25px;"><strong>Med v&auml;nliga h&auml;lsningar,<br />
                            Arrang&ouml;rskommitt&eacute;n<br /> Min Fotot&auml;vling</strong></p>
</div>
<div style="text-align: center; margin-top: 20px; font-size: 0.85em; color: #888; font-style: italic;">E-postinbjudan
    genererad av Claude Sonnet 4 (Anthropic)</div>